export default {
  description:
    'Folosește codul: {{code}} pentru a beneficia de reducere la următoarele {{count}} comenzi plasate aici.',
  discounts: {
    percentage: '{{discount}}%',
    fixed: '{{discount}}',
  },
  list: {
    item: {
      order: '{{orderNumber}}. Comandă',
    },
  },
  savings: {
    percentage: 'Economisești în total {{totalSaved}}%',
    fixed: 'Economisești în total {{totalSaved}}',
  },
  apply: 'Aplică',
  applied: 'Aplicat',
  remove: 'Elimină',
  custom_button: {
    done: 'Gata',
  },
};
